var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHimmatsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 43,
    viewBox: "0 0 53 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5357 26.636C50.3439 30.1516 47.2584 32.9619 43.5611 32.2061L43.317 32.1442C42.9509 32.0509 42.4974 31.7927 41.9649 31.3013C41.4383 30.8153 40.8783 30.1424 40.296 29.2948C39.2766 27.8112 38.232 25.8579 37.2082 23.5971L36.7707 22.6093C35.9573 20.7267 35.8247 19.6669 35.9664 19.1022C36.0269 18.8619 36.1371 18.7093 36.2994 18.5904C36.4814 18.4572 36.7704 18.3376 37.217 18.2606C38.1295 18.1033 39.4233 18.1662 41.0927 18.3342C42.706 18.4966 44.6828 18.7586 46.7456 18.9316L46.7466 18.9313C46.9884 18.9548 47.2106 18.9754 47.4214 18.9972L48.0388 19.0714L48.04 19.0721L48.3989 19.1326C50.1441 19.4805 51.1456 20.4591 51.6379 21.6971C52.1845 23.0721 52.1359 24.8656 51.5357 26.636Z",
    stroke: "url(#paint0_linear_173_24)",
    strokeWidth: 1.74436
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1443 1.48242C38.6139 1.3103 40.3338 1.82148 41.8884 2.85938C44.9758 4.92059 46.891 8.62817 45.2039 12.0039L45.0818 12.2236C44.8966 12.5539 44.5303 12.9247 43.9197 13.3115C43.3155 13.6943 42.5225 14.0612 41.5544 14.4043C39.8598 15.0049 37.7029 15.5084 35.2478 15.9121L34.1775 16.0791C32.1486 16.3775 31.0906 16.2313 30.5818 15.9482C30.3653 15.8277 30.2464 15.6817 30.1736 15.4941C30.092 15.2839 30.0513 14.9738 30.0925 14.5225C30.1767 13.6003 30.5724 12.3669 31.1667 10.7979C31.74 9.28456 32.502 7.44747 33.2019 5.50391C33.289 5.27162 33.3681 5.05798 33.4451 4.85645L33.6765 4.2793L33.6775 4.27832C34.4572 2.44951 35.733 1.64784 37.1443 1.48242Z",
    stroke: "url(#paint1_linear_173_24)",
    strokeWidth: 1.74436
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7219 34.6086C33.569 37.7924 29.1279 40.0545 24.2935 38.8426L24.0756 38.7877C23.6976 38.6427 23.2748 38.3618 22.815 37.9052C22.2655 37.3595 21.7023 36.6054 21.138 35.6612C20.1501 34.0082 19.2019 31.8475 18.3298 29.3881L17.9607 28.3163C17.4624 26.822 17.6089 25.9285 17.9644 25.3682C18.3369 24.7813 19.0831 24.3263 20.2803 24.0349C22.6927 23.4477 26.2423 23.6831 29.711 23.9667C31.0898 24.0883 32.2303 24.4317 33.1892 24.9263L33.589 25.1468C35.7133 26.4167 36.7225 28.0211 36.9912 29.6299C37.2636 31.2618 36.7941 33.0229 35.7219 34.6086Z",
    stroke: "url(#paint2_linear_173_24)",
    strokeWidth: 1.74436
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32593 17.4824C5.24552 16.9443 6.2189 16.8069 7.2146 16.9912C9.25744 17.3694 11.4481 19.1231 13.1296 21.6934C14.7962 24.2409 15.8552 27.4356 15.7576 30.4561C15.6609 33.4455 14.4375 36.2569 11.5242 38.1963L11.5125 38.2041L11.5007 38.2129C11.4105 38.2773 11.3163 38.3315 11.1804 38.4092L10.741 38.6611V38.6982C8.65068 39.9604 6.54241 40.7491 4.53491 41.1719C4.38763 41.2012 4.1852 41.1792 3.87769 40.873C3.55305 40.5498 3.20601 39.9922 2.86792 39.1895C2.19676 37.5959 1.66876 35.3026 1.32495 32.8066C0.98268 30.3217 0.831089 27.692 0.887451 25.4521C0.915631 24.3323 0.995405 23.323 1.12573 22.4854C1.24196 21.7385 1.39159 21.1747 1.55347 20.7988L1.62378 20.6494C2.45766 19.0215 3.39407 18.0278 4.32593 17.4824Z",
    stroke: "url(#paint3_linear_173_24)",
    strokeWidth: 1.74436
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6971 3.92383C15.662 3.78979 16.862 3.84046 18.2216 3.99805C19.5754 4.15498 21.027 4.41016 22.495 4.66113V4.66016C22.6923 4.69603 22.8805 4.73167 23.0516 4.76562H23.0526C25.0433 5.21242 26.1814 6.52175 26.6776 8.28809C27.1866 10.1002 27.0068 12.3883 26.2538 14.585C25.5018 16.7785 24.2142 18.7737 22.6337 20.0264C21.079 21.2585 19.2783 21.7535 17.3475 21.1035L17.3485 21.0986C17.0456 20.9968 16.6215 20.6541 16.1268 19.8809C15.6476 19.1319 15.1755 18.095 14.7245 16.8154C13.9366 14.58 13.2481 11.7064 12.6874 8.57422L12.455 7.21777L12.454 7.2168L12.4198 6.98047C12.2692 5.83121 12.4812 5.17718 12.788 4.78809C13.1246 4.36141 13.7267 4.05867 14.6971 3.92383Z",
    stroke: "url(#paint4_linear_173_24)",
    strokeWidth: 1.74436
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_24",
    x1: 42.4696,
    y1: 15.9333,
    x2: 47.0014,
    y2: 32.8463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_173_24",
    x1: 37.9587,
    y1: 0.577148,
    x2: 37.9587,
    y2: 17.1159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_173_24",
    x1: 25.5382,
    y1: 21.7204,
    x2: 30.3167,
    y2: 39.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_173_24",
    x1: 8.31986,
    y1: 16.042,
    x2: 8.31986,
    y2: 42.0544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_173_24",
    x1: 15.1429,
    y1: 1.08109,
    x2: 19.6679,
    y2: 22.2643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68C0FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 42.0462,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHimmatsLogo);
export default __webpack_public_path__ + "static/media/himmats-logo.d0141466fe37ef4974750d82a6f4d908.svg";
export { ForwardRef as ReactComponent };